import React from 'react';
import { Box, BoxProps } from '@mui/material';
import { DesignMode, getDesignTokens } from './designTokens';

type StatusPillTone = 'info' | 'success' | 'warning' | 'danger' | 'neutral';

type StatusPillProps = BoxProps & {
  tone?: StatusPillTone;
  mode?: DesignMode;
};

const getTones = (
  mode: DesignMode,
  tokens: ReturnType<typeof getDesignTokens>
) =>
  ({
    info: {
      color: mode === 'light' ? tokens.colors.tealDeep : tokens.colors.teal
    },
    success: {
      color: mode === 'light' ? '#117447' : tokens.colors.green
    },
    warning: {
      color: mode === 'light' ? '#8b6112' : tokens.colors.gold
    },
    danger: {
      color: mode === 'light' ? '#9d2d2d' : tokens.colors.red
    },
    neutral: {
      color: tokens.colors.textMuted
    }
  }) satisfies Record<StatusPillTone, object>;

export const StatusPill = ({
  tone = 'info',
  mode = 'light',
  sx,
  children,
  ...props
}: StatusPillProps) => {
  const tokens = getDesignTokens(mode);
  const tones = getTones(mode, tokens);

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        minHeight: 0,
        px: 0,
        border: 0,
        background: 'transparent',
        boxShadow: 'none',
        fontSize: 13,
        fontWeight: 850,
        lineHeight: 1.25,
        letterSpacing: '0.01em',
        whiteSpace: 'nowrap',
        ...tones[tone],
        ...sx
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
